import React from "react";
import StarRatingComponent from "react-star-rating-component";
import { active_starIcon, inactive_starIcon } from "../Images";
import './feedback.css'

export default class RatingComponent extends React.Component {
  state = {
    rating: this.props.resourceRating || 0
  };
  onStarClick = nextValue => {
    const { data, resourceRating } = this.props;
    if (data) {
      data["ratings"] = nextValue;
      return data
    } else {
      return this.props.setResourceRating(nextValue)
    }
  };
  onStarHover = nextValue => {
    this.setState({ rating: nextValue });
  };
  onStarHoverOut = () => {
    this.setState({ rating: 0 });
  };

  render() {
    const { data, isMobile, fromNestedData, resourceRating } = this.props;
    const rating = this.state.rating || (data && data["ratings"]) || resourceRating || 0;
    return (
      <div>
        <StarRatingComponent
          value={rating}
          starCount={5}
          onStarClick={this.onStarClick}
          onStarHover={this.onStarHover}
          onStarHoverOut={this.onStarHoverOut}
          renderStarIcon={(index, value) => {
            return index <= value ? (
              fromNestedData ? 
              <div className={isMobile ? "starBoxFormSM" : "starBoxFormMD"} >
                <img src={active_starIcon} className= {isMobile ? "starIconFormSM" : "starIconFormMD"}></img>
              </div> :
               <div className={isMobile ? "starBoxSM" : "starBoxMD"} >
                <img src={active_starIcon} className={isMobile ? "starIconSM" : "starIconMD"} ></img>
              </div>

            ) : (
              fromNestedData ?
                <div className= {isMobile ? "starBoxFormSM" : "starBoxFormMD"}>
                  <img src={inactive_starIcon} className={isMobile ? "starIconFormSM" : "starIconFormMD"}></img>
                </div> :
                <div className= {isMobile ? "starBoxSM" : "starBoxMD"} >
                  <img src={inactive_starIcon} className={isMobile ? "starIconSM" : "starIconMD"}></img>
                </div>
            );
          }}
        />
      </div>
    );
  }
}
